<template>
  <div class="trend-group">
    <!-- <h1>Featured Industry Trends</h1>
    <div class="trend-group__group">
      <template
        v-for="(trend, index) in trends"
      >
        <Trend
          :key="index"
          :trend="trend" 
        />
      </template>
    </div> -->
    <div v-if="debugging">
      Total: {{ trendCount.total }}<br>
      Current: {{ trendCount.current }}<br>
      Per Page: {{ trendCount.perPage }}<br>
      Page: {{ trendCount.page }}<br>
      Next: {{ trendCount.next }}<br><br>
      Count: {{ count }}
    </div>
    <!-- <h2>Featured Industry Trends</h2> -->
    <ul class="trend-list">
      <template v-for="(trend, index) in filteredTrends">
        <li
          v-show="!trend.isExcluded && index < trendsSoFar"
          :key="index"
        >
          <transition
            name="trend-more"
          >
            <Trend
              :trend="trend" 
            />
          </transition>
          <div
            v-if="debugging"
            :key="index"
          >
            {{ index }}
          </div>
          <!-- counter: {{ liveCounter }} -->
        </li>
      </template>
    </ul>
    <div class="view-more-container">
      <button
        v-if="trendCount.current > trendsSoFar"
        class="button"
        @click="addMoreTrends"
      >
        View {{ trendCount.next }} More of {{ trendsLeft }} {{ trendsLeft > 1 ? 'Trends' : 'Trend' }}
      </button>
    </div>
  </div>
</template>

<script>
import Trend from "./items/Trend.vue"

import store from "../store"

export default {
  name: "TrendsView",
  components: {
    Trend
  },
  data: () => {
    return {
      trendCount: {
        current: 9,
        total: 0,
        perPage: 12,
        page: 1,
        next: 0
      },
      liveCounter: 0,
      debugging: false
    }
  },
  computed: {
    // segments: function(trend) {
    //   this.trends
    //   return segmentList
    // }
    count: function() {
      return store.state.items.filter(i => {
        return !i.isExcluded;
      }).length;
    },
    filteredTrends: function() {
      //console.log(this.$store.state.items);
      // this.trendCount.total = this.count;
      // this.trendCount.current = this.count < this.trendCount.current ? this.count : this.trendCount.current;
      return this.$store.state.items.filter(function(item) {
        return !item.isExcluded;
      });
    },
    trendsLeft: function() {
      return this.trendCount.current - (this.trendCount.perPage * this.trendCount.page)
    },
    trendsSoFar: function() {
      return this.trendCount.perPage * this.trendCount.page
    }
  },
  updated() {
    this.trendCount.current = this.count
    this.trendCount.next = (this.trendCount.current >= this.trendCount.perPage * (this.trendCount.page + 1)) ? this.trendCount.perPage : this.trendCount.current - (this.trendCount.perPage * this.trendCount.page)
    this.$emit('updateCount', this.count)
  },
  created() {
    this.trendCount.total = this.count
    this.trendCount.current = this.count
    this.trendCount.next = (this.trendCount.current >= this.trendCount.perPage * (this.trendCount.page + 1)) ? this.trendCount.perPage : this.trendCount.current - (this.trendCount.perPage * this.trendCount.page)
  },
  methods: {
    addMoreTrends: function() {
      ++this.trendCount.page
      // this.trendCount.current = this.trendCount.current + this.trendCount.perPage
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'trend engagement',
          eventAction: 'button click',
          eventLabel: 'View More Trends',
        });
      }
    },
    incrementCounter: function(trend) {
      if (!trend.isExcluded) {
        this.liveCounter++
      }
      // console.log('liveCounter', this.liveCounter)
    }
  }
};
</script>
